import straps from "../assets/json/strapsNew.json"; // Feb 9th, 2022
import gold from "../assets/img/anagrams/111.11.BDI_8130_LOEWE_1F.png";
import palladium from "../assets/img/anagrams/111.11.SDI_9230_LOEWE_1F.png";

let anagrams =
  window.loeweStrapTool && window.loeweStrapTool.anagrams
    ? window.loeweStrapTool.anagrams
    : {
        gold: gold,
        palladium: palladium
      };

let strapsData =
  window.loeweStrapTool && window.loeweStrapTool.straps
    ? window.loeweStrapTool.straps
    : straps;

strapsData = strapsData
  .map(strap => {
    return {
      ...strap,
      ...{
        anagram: {
          is_anagram: true,
          size: "1.1x1.1x1.1 cm",
          image: strap.images[6]
            ? strap.images[6].image6
            : StrapsService.getStrapAnagram(strap.id)
        }
      }
    };
  })
  
class StrapsService {
  static getStrap(index) {
    return strapsData[index];
  }
  static getStraps() {
    return strapsData;
  }
  static getStrapType(type) {
    return strapsData.filter(item => item.category_type === type);
  }
  static getStrapAnagram(id) {
    switch (id) {
      case "0010281186":
        return anagrams.palladium;
      case "0010281160":
        return anagrams.gold;
      case "0010281194":
        return anagrams.palladium;
      case "0010281152":
        return anagrams.gold;
      case "0010281202":
        return anagrams.palladium;
      case "0010281178":
        return anagrams.gold;
      case "0010281210":
        return anagrams.palladium;
      default:
        break;
    }
  }
}

export default StrapsService;
